import i18n from '@/locales'

export const statusMap = {
  completed: i18n.t('common_441'),
  active: i18n.t('common_440'),
  externally_terminated: i18n.t('common_442'),
}
